import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import CozyNook from "./pages/CozyNook";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Create from "./pages/Create";
import Engage from "./pages/Engage";
import Build from "./pages/Build";
import Space from "./pages/Space";
import Yard from "./pages/Yard";
import RSVP from "./pages/RSVP";

function App() {
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile screen
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Redirect Firebase preview
  useEffect(() => {
    const host = window.location.hostname;
    if (host.includes("heydiari.web.app") || host.includes("heydiari.firebaseapp.com")) {
      const newUrl = "https://heydiari.com" + window.location.pathname + window.location.search;
      window.location.replace(newUrl);
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
        <Route path="/" element={<Landing />} />
        <Route path="/engage" element={<Engage />} />
        <Route path="/yard" element={<Yard />} />
        </Route>

        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />

        <Route
          path="/nook"
          element={
            <ProtectedRoute>
              <CozyNook />
            </ProtectedRoute>
          }
        />

        <Route path="/create" element={<Create />} />

        <Route path="/update" element={<Create />} />

        <Route path="/build" element={<Build />} />

        <Route path="/:spacelink/customize" element={<Build />} />

        <Route path="/:spacelink/RSVP" element={<RSVP />} />

        <Route path="/:spacelink" element={<Space />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
